export const CaseCollection = {
  namespaced: true,

  state: {
    recent: [],
    collectionsCount: 0,
    followedCollectionsCount: 0,
    currentCollection: null,
  },

  getters: {},

  mutations: {
    setCollectionsCount(state, newCount) {
      state.collectionsCount = newCount;
    },
    setFollowedCollectionsCount(state, newCount) {
      state.followedCollectionsCount = newCount;
    },
    setRecentCollections(state, collections) {
      state.recent = [...collections];
    },
    setCurrentGroup(state, collection) {
      state.currentCollection = collection;
    },
  },

  actions: {
    initialize({ commit }, data) {
      if (data) {
        if (data.recentCollections) {
          commit('setRecentCollections', data.recentCollections);
        }

        if (data.collectionsCount !== undefined) {
          commit('setCollectionsCount', data.collectionsCount);
        }
        if (data.followedCollectionsCount !== undefined) {
          commit('setFollowedCollectionsCount', data.followedCollectionsCount);
        }
      }
    },
  },
};
